var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm2.083 20.878V31.76h-4.502V20.879h-2.249v-3.75h2.25v-2.251c0-3.059 1.27-4.878 4.878-4.878h3.004v3.75h-1.878c-1.405 0-1.498.524-1.498 1.502l-.005 1.877h3.402l-.398 3.75h-3.004z",
    fill: "currentColor"
  })));
}

export default SvgFacebook;